export default __webpack_public_path__ + "static/media/idcard.4ecbad54.svg";